import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Privacy Policy" }) => {
  return (

          <Text style={{textAlign: "justify", margin: "5% 10%"}}>

            <headingText style={{fontWeight: "bold", textAlign: "center"}}>AVISO DE PRIVACIDAD</headingText>

            <p>
              Interacción a través de nuestro Asistente Virtual (Chatbot) en Facebook Messenger

Cuando un usuario interactúa con nuestro asistente virtual (chatbot) a través de la plataforma de Facebook Messenger, se recabará información específica para proporcionar una respuesta automatizada y eficiente a sus consultas. Los datos personales tratados a través de este canal son los siguientes:

Datos Personales proporcionados por Meta:

Identificador de Usuario de Facebook (Sender ID): Un número único que la plataforma asigna a su perfil para poder dirigirle las respuestas.

Nombre y Apellido: Según la configuración pública de su perfil de Facebook.

Datos generados durante la interacción:

Contenido de los mensajes: El texto de las preguntas, solicitudes y toda la información que el usuario escriba en la conversación.

La finalidad del tratamiento de estos datos es exclusivamente para:

Atender y gestionar sus consultas: Identificar la intención de su pregunta y procesarla para ofrecer una respuesta coherente y útil sobre los procesos académicos, administrativos, técnicos y financieros del programa Bécalos.

Personalizar la experiencia: Dirigirnos a usted por su nombre para mantener una comunicación cercana y profesional.

Mantener el historial de la conversación: Conservar un registro temporal de la interacción para dar contexto a preguntas futuras y mejorar la calidad del servicio.

Procesamiento con herramientas de terceros: Para poder generar las respuestas, el contenido de sus mensajes será procesado por herramientas de inteligencia artificial de terceros, como los modelos de lenguaje de OpenAI, y consultado en bases de conocimiento alojadas en servicios como Pinecone. Estos proveedores de servicios no almacenarán su información personal de forma permanente ni la utilizarán para fines distintos a la generación de la respuesta solicitada en el momento de la interacción.

Fundación Televisa, A.C. se compromete a que los datos recabados a través del chatbot serán tratados bajo las mismas medidas de seguridad y confidencialidad descritas en el presente Aviso de Privacidad, asegurando que su uso se limite estrictamente a la finalidad aquí expuesta.
            </p>
          </Text>
  );
};
